export default "/images/NIST_Logo.png";